import { faUserSlash } from "@fortawesome/pro-light-svg-icons";

import { T } from "@repo/transifex";

import { Modal, type ModalProps } from "../shared/modal";
import { ModalIcon } from "../shared/modal-icon";
import { ModalTitle } from "../shared/modal-title";
import { ModalButton } from "../shared/modal-button";
import { ModalButtonGroup } from "../shared/modal-button-group";

type ModalErrorQrProps = Pick<ModalProps, "open"> & {
  onClose?: () => void;
};

export const ModalErrorQr = ({ onClose, open = true }: ModalErrorQrProps) => {
  return (
    <Modal backdropVariant="error" open={open}>
      <div className="flex flex-col items-center gap-16 px-32 text-center">
        <ModalIcon icon={faUserSlash} variant="error" />

        <ModalTitle size="9xl" variant="error" weight="black">
          <T _str="User not recognised" />
        </ModalTitle>

        <p className="text-6xl text-kiosk-text-white">
          <T _str="Please try again or contact staff" />
        </p>

        <ModalButtonGroup className="mt-16">
          <ModalButton variant="idle" onClick={onClose}>
            <T _str="Close" />
          </ModalButton>
        </ModalButtonGroup>
      </div>
    </Modal>
  );
};
